<template>
    <div class="filter-search">
        <div class="filter-search__wrapper">
            <input
                :id="searchInputId"
                v-model="query"
                name="query"
                class="input-custom"
                :aria-label="`Wyszukiwanie w filtrze ${name} – pole edycji`"
                @input="onInput"
            />
            <SearchIcon class="filter-search__icon" width="24" height="24" />
        </div>

        <p
            v-if="displayMessage && query && !queryResults.length"
            class="filter-search__noresult"
        >
            {{ i18n('No results') }}
        </p>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { debounce, deburr } from 'lodash'
import SearchIcon from '@icons/search.svg'
export default {
    components: {
        SearchIcon
    },
    props: {
        searchInputId: {
            type: String,
            default: ''
        },
        filter: {
            type: Array,
            required: true
        },
        name: {
            type: String,
            required: true,
            default: ''
        },
        filterName: {
            type: String,
            required: true,
            default: ''
        }
    },
    data() {
        return {
            query: null,
            queryResults: [],
            searchingTimeout: null,
            displayMessage: false
        }
    },
    computed: {
        ...mapGetters(['i18n'])
    },
    watch: {
        filter() {
            if (this.queryResults.length) {
                this.search()
            }
        }
    },
    methods: {
        search() {
            const query = deburr(this.query).toLowerCase()
            this.handleMessage()
            if (!query.length) {
                this.queryResults = []
            } else {
                this.queryResults = [...this.filter]
                    .filter(({ label }) =>
                        deburr(label).toLowerCase().includes(query)
                    )
                    .map(({ ...filter }) => {
                        const queryToReplace = filter.label.match(
                            new RegExp(this.query, 'i')
                        )?.[0]

                        filter.label = filter.label.replace(
                            queryToReplace,
                            `<strong>${queryToReplace}</strong>`
                        )

                        return filter
                    })
            }
            this.$emit('search', this.queryResults)
        },
        handleMessage() {
            this.displayMessage = false
            clearTimeout(this.searchingTimeout)
            this.searchingTimeout = setTimeout(() => {
                if (this.query.length && !this.queryResults.length) {
                    this.displayMessage = true
                }
            }, 300)
        },
        onInput: debounce(function () {
            this.search()
        }, 100)
    }
}
</script>
<style lang="scss">
.filter-search {
    label {
        display: none;
    }
    input {
        padding: 6px 16px;
        font-size: 1.6rem;
        height: 56px;
    }

    &__wrapper {
        position: relative;
        height: 56px;
    }

    &__icon {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 15px;
        margin: auto;
        color: $sherpa-blue;
    }

    &__noresult {
        padding: 0.5rem 0;
        word-break: break-word;
    }
}
</style>
